// extracted by mini-css-extract-plugin
export var dataCell = "_ha-2";
export var dataRow = "_ha-0";
export var headerRow = "_ha-1";